import { Link } from "@merge-api/merge-javascript-shared";
import { Minus } from "lucide-react";
import { getBlueprintEditorPath } from "../../../../../router/RouterUtils";
import { BlueprintVersionMeta } from "../../types";

interface Props {
  integrationID: string;
  blueprint_details: BlueprintVersionMeta[];
}

const AutomatedModifiedAtFiltersTableBlueprintsCell = ({
  integrationID,
  blueprint_details,
}: Props) => {
  if (blueprint_details.length === 0) {
    return <Minus size={16} className="text-gray-40" />;
  }

  return (
    <ul className="list-disc pl-4">
      {blueprint_details.map((blueprint_detail) => (
        <li key={blueprint_detail.blueprint_version_id}>
          <Link
            className="block truncate"
            variant="md"
            href={getBlueprintEditorPath(integrationID, blueprint_detail.blueprint_version_id)}
            target="_blank"
          >
            {blueprint_detail.blueprint_name}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default AutomatedModifiedAtFiltersTableBlueprintsCell;
